export const applyForChangeLocalization = {
  mainHeading: {
    en: 'Apply for a change',
    nb: 'Søk om endring',
    nn: 'Søk om endring',
  },
  mainParagraph: {
    en: 'If you need changes to loan terms or security associated with your loan, you can use one of the application forms below. You can also apply for installment deferral or payment deferral.',
    nb: 'Har du behov for endringer i lånevilkår eller sikkerheter knyttet til lånet, kan du benytte et av søknadsskjemaene nedenfor. Du kan også søke om avdragsutsettelse eller betalingsutsettelse.',
    nn: 'Har du behov for endringer i lånevilkår eller sikkerheiter knytta til lånet, kan du nytte ein av søknadsskjemaene nedanfor. Du kan også søkje om avdragsutsetjing eller betalingsutsetjing.',
  },
  sendMailSummary: {
    en: 'Need to change the disbursement deadline, due date or repayment term?',
    nb: 'Vil du endre utbetalingsfrist, forfallsdato eller terminlengde?',
    nn: 'Vil du endre utbetalingsfrist, forfallsdato eller terminlengd?',
  },
  sendMailContent: {
    en: 'If you need to make changes to the disbursement deadline, due date or repayment term, please email kundesupport@innovasjonnorge.no.',
    nb: 'Har du behov for å endre utbetalingsfrist, forfallsdato eller terminlengde sender du en e-post til kundesupport@innovasjonnorge.no.',
    nn: 'Har du behov for å endre utbetalingsfrist, forfallsdato eller terminlengd sender du ein e-post til kundesupport@innovasjonnorge.no.',
  },
  changeFeeHeading: {
    en: 'Change fee',
    nb: 'Endringsgebyr',
    nn: 'Endringsgebyr',
  },
  changeFeeParagraph: {
    en: 'Processing an application for change or deferral incurs a cost of NOK 1,250 per account. In cases where the cost exceeds NOK 1,250, we will contact you with information about the fee amount. Once you have approved the fee, we can process the case. The fee will appear in the decision letter and will be charged on the next invoice.',
    nb: 'Behandling av en søknad om endring eller utsettelse medfører en kostnad fra 1250,- NOK per konto. I de tilfeller kostnaden blir høyere enn 1250,- NOK vil du bli kontaktet av oss med informasjon om størrelse på gebyr. Når du har godkjent gebyret kan vi behandle saken. Gebyr vil fremkomme i vedtaksbrevet, og effektueres på neste faktura.',
    nn: 'Handsaming av ein søknad om endring eller utsetjing medførar ein kostnad frå 1250,- NOK per konto. I dei tilfella kostnaden blir høgare enn 1250,- NOK vil du bli kontakta av oss med informasjon om storleiken på gebyret. Når du har godkjent gebyret kan vi handsame saka. Gebyr vil framkomme i vedtaksbrevet, og gjeldast på neste faktura.',
  },
  creditInformationHeading: {
    en: 'Credit information',
    nb: 'Kredittopplysninger',
    nn: 'Kredittopplysningar',
  },
  creditInformationParagraph: {
    en: 'When processing your application, we have the opportunity to obtain credit information about your business.',
    nb: 'Ved behandling av søknaden har vi anledning til å innhente kredittopplysninger om din virksomhet.',
    nn: 'Ved handsaming av søknaden har vi høve til å innhente kredittopplysningar om virksemda di.',
  },
  aboutHeading: {
    en: 'About the application',
    nb: 'Om søknaden',
    nn: 'Om søknaden',
  },
  termsHeading: {
    en: 'Terms',
    nb: 'Vilkår',
    nn: 'Vilkår',
  },
  interestRatesHeading: {
    en: 'This is how interest rates and the repayment plan are affected',
    nb: 'Slik påvirkes renter og nedbetalingsplan',
    nn: 'Slik påverkast renter og nedbetalingsplan',
  },
  postponementHeading: {
    en: 'Postponement',
    nb: 'Utsettelse',
    nn: 'Utsetjing',
  },
  collateralHeading: {
    en: 'Collateral and security changes',
    nb: 'Endringer i pant og sikkerhet',
    nn: 'Endringar i pant og sikkerheit',
  },
  otherTermsHeading: {
    en: 'Other terms changes',
    nb: 'Endringer i øvrige vilkår',
    nn: 'Endringar i øvrige vilkår',
  },
  otherInquiriesHeading: {
    en: 'Other inquiries',
    nb: 'Andre henvendelser',
    nn: 'Andre henvendingar',
  },
  otherInquiriesParagraph: {
    en: 'You will find more information about changes related to, among other things, debtor change, bankruptcy, liquidation of company and breach of loan on our website.',
    nb: 'Du finner mer informasjon om endring knyttet til blant annet debitorskifte, konkurs, avvikling av selskap og mislighold av lån på nettsidene våre.',
    nn: 'Du finn meir informasjon om endring knytta til mellom anna debitorskifte, konkurs, avvikling av selskap og mislighold av lån på nettsidene våre.',
  },
  applicationMaintenanceAmortizationDelaySummary: {
    en: 'Installment deferral',
    nb: 'Avdragsutsettelse',
    nn: 'Avdragsutsetjing',
  },
  applicationMaintenanceAmortizationDelayAbout: {
    en: 'You can apply for a deferment of one or more installments. Interest and installment fees must be paid as usual during the same period.',
    nb: 'Du kan søke avdragsutsettelse på én eller flere terminer. Renter og termingebyr må betales som normalt i samme periode.',
    nn: 'Du kan søkje avdragsutsetjing på éin eller fleire terminar. Renter og termingebyr må betalast som normalt i same periode.',
  },
  applicationMaintenanceAmortizationDelayTerms1: {
    en: 'Overdue interest and costs must be up to date',
    nb: 'Forfalte renter og omkostninger må være à jour',
    nn: 'Forfalte renter og omkostningar må vera à jour',
  },
  applicationMaintenanceAmortizationDelayTerms2: {
    en: 'It must also be possible to document payment relief/installment deferral with other lenders for the same period',
    nb: 'Det må også kunne dokumenteres betalingslettelse/avdragsutsettelse hos andre lånegivere for samme periode',
    nn: 'Det må også kunna dokumenterast betalingsletting/avdragsutsetjing hos andre lånegivarar for same periode',
  },
  applicationMaintenanceAmortizationDelayInterestRatesParagraph1: {
    en: 'Interest and fees must be paid as usual during the period you are granted installment deferral. The original invoice will be used.',
    nb: 'Renter og gebyrer må betales som normalt i perioden man får innvilget avdragsutsettelse. Original faktura benyttes.',
    nn: 'Renter og gebyrer må betalast som normalt i perioden ein får innvilga avdragsutsetjing. Original faktura nyttast.',
  },
  applicationMaintenanceAmortizationDelayInterestRatesParagraph2: {
    en: 'Penalty interest is calculated from the due date and will be included in the next invoice.',
    nb: 'Forsinkelsesrenter beregnes fra forfallsdato og vil inkluderes på neste faktura.',
    nn: 'Forsinkingsrenter blir rekna frå forfallsdato og vil inkluderast på neste faktura.',
  },
  applicationMaintenanceAmortizationDelayInterestRatesParagraph3: {
    en: 'The loan term will normally be extended corresponding to the interest-free period, and the repayment plan will be updated.',
    nb: 'Løpetiden vil normalt forlenges tilsvarende den avdragsfrie perioden, og nedbetalingsplanen vil oppdateres',
    nn: 'Løpetida vil normalt forlengjast tilsvarande den avdragsfrie perioden, og nedbetalingsplanen vil oppdaterast',
  },
  applicationMaintenanceAmortizationDelayButton: {
    en: 'Apply for installment deferral',
    nb: 'Søk om avdragsutsettelse',
    nn: 'Søk om avdragsutsetjing',
  },
  applicationMaintenanceAmortizationDelayAlertHeading: {
    en: 'You cannot apply for installment deferral',
    nb: 'Du kan ikke søke om avdragsutsettelse',
    nn: 'Du kan ikkje søkje om avdragsutsetjing',
  },
  applicationMaintenanceAmortizationDelayAlertParagraph: {
    en: 'If you have questions related to this, you can contact us at kundesupport@innovasjonnorge.no.',
    nb: 'Har du spørsmål knyttet til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
    nn: 'Har du spørsmål knytta til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
  },
  deferralPaymentSummary: {
    en: 'Payment deferral',
    nb: 'Betalingsutsettelse',
    nn: 'Betalingsutsetjing',
  },
  deferralPaymentAbout: {
    en: 'You can apply for payment deferral for installments, interest and installment fees for the oldest unpaid invoice and up to three months. Penalty interest will accrue until the invoice is paid. There is no processing fee for this application.',
    nb: 'Du kan søke om betalingsutsettelse for avdrag, renter og termingebyr for eldste ubetalte faktura og inntil tre måneder. Det vil påløpe forsinkelsesrenter frem til fakturaen er betalt. Det tilkommer ikke behandlingsgebyr for denne søknaden.',
    nn: 'Du kan søkje om betalingsutsetjing for avdrag, renter og termingebyr for eldste ubetalte faktura og inntil tre månader. Det vil påløpe forsinkingsrenter fram til fakturaen er betalt. Det tilkjem ikkje behandlingsgebyr for denne søknaden.',
  },
  deferralPaymentTermsOld1: {
    en: 'You cannot apply for payment deferral on invoices that have been sent to debt collection',
    nb: 'Du kan ikke søke betalingsutsettelse på fakturaer som er sendt til inkasso',
    nn: 'Du kan ikkje søkje betalingsutsetjing på fakturar som er sendt til inkasso',
  },
  deferralPaymentTermsOld2: {
    en: 'It is only possible to apply digitally for payment deferral once per loan',
    nb: 'Det er kun mulig å søke digitalt om betalingsutsettelse én gang per lån',
    nn: 'Det er berre mogleg å søkje digitalt om betalingsutsetjing éin gong per lån',
  },
  deferralPaymentTerms1: {
    en: 'You cannot apply for payment deferral on invoices that have been sent to debt collection',
    nb: 'Du kan ikke søke betalingsutsettelse på fakturaer som er sendt til inkasso',
    nn: 'Du kan ikkje søkje betalingsutsetjing på fakturar som er sendt til inkasso',
  },
  deferralPaymentTerms2: {
    en: 'You can apply for a payment deferral up to three times per loan',
    nb: 'Du kan søke om betalingsutsettelse opptil tre ganger per lån',
    nn: 'Du kan søkje om betalingsutsetjing opptil tre gonger per lån',
  },
  deferralPaymentTerms3: {
    en: 'At least 12 months must have passed since your previous application for a payment deferral',
    nb: 'Det må ha gått minst 12 måneder siden forrige søknad om betalingsutsettelse',
    nn: 'Det må ha gått minst 12 månader sidan den siste søknaden om betalingsutsetjing',
  },
  deferralPaymentInterestRatesParagraph1: {
    en: 'The repayment plan is not changed',
    nb: 'Nedbetalingsplanen endres ikke',
    nn: 'Nedbetalingsplanen endrast ikkje',
  },
  deferralPaymentInterestRatesParagraph2: {
    en: 'Interest, installments and installment fees are deferred during the period payment deferral is granted',
    nb: 'Renter, avdrag og termingebyr forskyves i perioden det er innvilget betalingsutsettelse',
    nn: 'Renter, avdrag og termingebyr blir forskyvne i perioden det er innvilga betalingsutsetjing',
  },
  deferralPaymentInterestRatesParagraph3: {
    en: 'Penalty interest is calculated from the original due date until payment is received',
    nb: 'Forsinkelsesrenter beregnes fra den opprinnelige forfallsdatoen og frem til betaling er mottatt',
    nn: 'Forsinkingsrenter blir rekna frå den opphavlege forfallsdatoen og fram til betaling er motteken',
  },
  deferralPaymentInterestRatesParagraph4: {
    en: 'To avoid additional costs, we recommend that you pay the invoice as soon as possible',
    nb: 'For å unngå ekstra kostnader anbefaler vi at fakturaen betales så snart som mulig',
    nn: 'For å unngå ekstra kostnadar tilråder vi at fakturaen blir betalt så snart som mogleg',
  },
  deferralPaymentButton: {
    en: 'Apply for payment deferral',
    nb: 'Søk om betalingsutsettelse',
    nn: 'Søk om betalingsutsetjing',
  },
  deferralPaymentAlertHeading: {
    en: 'You cannot apply for payment deferral',
    nb: 'Du kan ikke søke om betalingsutsettelse',
    nn: 'Du kan ikkje søkje om betalingsutsetjing',
  },
  deferralPaymentAlertParagraphOld: {
    en: 'This may be because your loan has previously been granted payment deferral. To apply for new payment deferral, you can contact us at kundesupport@innovasjonnorge.no.',
    nb: 'Dette kan være fordi lånet tidligere har fått innvilget betalingsutsettelse. For å søke om ny betalingsutsettelse kan du kontakte oss på kundesupport@innovasjonnorge.no.',
    nn: 'Dette kan vera fordi lånet tidlegare har fått innvilga betalingsutsetjing. For å søkje om ny betalingsutsetjing kan du kontakte oss på kundesupport@innovasjonnorge.no.',
  },
  deferralPaymentAlertParagraph: {
    en: 'This may be because your loan has previously been granted payment deferral. See terms for more information.',
    nb: 'Dette kan være fordi lånet tidligere har fått innvilget betalingsutsettelse. Se vilkår for mer informasjon.',
    nn: 'Dette kan vera fordi lånet tidlegare har fått innvilga betalingsutsetjing. Sjå vilkår for meir informasjon.',
  },
  releaseOfCollateralsSummary: {
    en: 'Waiver of security',
    nb: 'Frafall av sikkerheter',
    nn: 'Frafall av sikkerheiter',
  },
  releaseOfCollateralsAbout1: {
    en: 'If all or part of a pledged asset is to be removed from the pledged securities, Innovation Norway must give consent to this.',
    nb: 'Dersom hele eller deler av et panteobjekt skal utgå av pantesikkerhetene, skal Innovasjon Norge gi samtykke til dette.',
    nn: 'Dersom heile eller delar av eit panteobjekt skal utgå av pantesikkerheitene, skal Innovasjon Norge gje samtykke til dette.',
  },
  releaseOfCollateralsAbout2: {
    en: 'Waiver of security in an asset will typically include the entire asset - for example the entire claim pledge, the entire inventory pledge, the entire share pledge, or one or more specific farm numbers.',
    nb: 'Frafall av sikkerhet i et formuesgode vil typisk omfatte hele formuesgodet – f.eks. hele fordringspantet, hele varelagerpantet, hele aksjepantet, eller et eller flere spesifikke gårds- og bruksnumre.',
    nn: 'Frafall av sikkerheit i eit formuesgode vil typisk omfatte heile formuesgodet – t.d. heile fordringspantet, heile varelagerpantet, heile aksjepantet, eller eit eller fleire spesifikke gårds- og bruksnummer.',
  },
  releaseOfCollateralsTerms1: {
    en: 'As a general rule, approval of waiver of pledge will require that Innovation Norway is offered other security that Innovation Norway considers satisfactory, or that the loan is reduced corresponding to the value of the pledge that is deleted',
    nb: 'Som hovedregel vil innvilging av pantefrafall forutsette at Innovasjon Norge tilbys annen sikkerhet som Innovasjon Norge vurderer som tilfredsstillende, eller at lånet nedreguleres tilsvarende verdien av pantet som slettes',
    nn: 'Som hovudregel vil innvilging av pantefrafall føresetje at Innovasjon Norge blir tilbode annen sikkerheit som Innovasjon Norge vurderer som tilfredsstillande, eller at lånet blir nedregulert tilsvarande verdien av pantet som blir sletta',
  },
  releaseOfCollateralsTerms2: {
    en: 'If the pledge is to be sold, it is generally assumed that the sale proceeds are used to pay down the pledged debt',
    nb: 'Dersom pantet skal selges, forutsettes det som hovedregel at salgssummen benyttes til nedkvittering av pantegjelden',
    nn: 'Dersom pantet skal seljast, føresetjest det som hovudregel at salgssummen blir nytta til nedkvitering av pantegjelden',
  },
  releaseOfCollateralsButton: {
    en: 'Apply for waiver of security',
    nb: 'Søk om frafall av sikkerheter',
    nn: 'Søk om frafall av sikkerheiter',
  },
  releaseOfCollateralsAlertHeading: {
    en: 'You cannot apply for waiver of security',
    nb: 'Du kan ikke søke om frafall av sikkerheter',
    nn: 'Du kan ikkje søkje om frafall av sikkerheiter',
  },
  releaseOfCollateralsAlertParagraph: {
    en: 'If you have questions related to this, you can contact us at kundesupport@innovasjonnorge.no.',
    nb: 'Har du spørsmål knyttet til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
    nn: 'Har du spørsmål knytta til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
  },
  maintenancePriorityDeviationSummary: {
    en: 'Priority violation',
    nb: 'Prioritetsvikelse',
    nn: 'Prioritetsvikelse',
  },
  maintenancePriorityDeviationAbout: {
    en: "The application is used if a new loan has been taken out which is to be secured with a pledge in an asset and a new creditor requires that the new loan must have better priority than Innovation Norway's obligations. Upon approval of the application, the priority order will be changed.",
    nb: 'Søknaden benyttes dersom det er tatt opp nytt lån som skal sikres med pant i et formuesgode og ny kreditor krever at nytt lån skal ha bedre prioritet enn Innovasjon Norges obligasjoner. Ved innvilgelse av søknaden vil prioritetsrekken endres.',
    nn: 'Søknaden blir nytta dersom det er tatt opp nytt lån som skal sikrast med pant i eit formuesgode og ny kreditor krev at nytt lån skal ha betre prioritet enn Innovasjon Noregs obligasjonar. Ved innvilging av søknaden vil prioritetsrekja endrast.',
  },
  maintenancePriorityDeviationTerms1: {
    en: 'When applying for priority violation in real estate or vessels, it is preferable that an updated valuation is attached',
    nb: 'Ved søknad om prioritetsvikelse i fast eiendom eller fartøy, foretrekkes det at oppdatert verdivurdering vedlegges',
    nn: 'Ved søknad om prioritetsvikelse i fast eiendom eller fartøy, blir det føretrekke at oppdatert verdivurdering vedleggast',
  },
  maintenancePriorityDeviationButton: {
    en: 'Apply for priority violation',
    nb: 'Søk om prioritetsvikelse',
    nn: 'Søk om prioritetsvikelse',
  },
  maintenancePriorityDeviationAlertHeading: {
    en: 'You cannot apply for priority violation',
    nb: 'Du kan ikke søke om prioritetsvikelse',
    nn: 'Du kan ikkje søkje om prioritetsvikelse',
  },
  maintenancePriorityDeviationAlertParagraph: {
    en: 'If you have questions related to this, you can contact us at kundesupport@innovasjonnorge.no.',
    nb: 'Har du spørsmål knyttet til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
    nn: 'Har du spørsmål knytta til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
  },
  maintenanceAmendmentOfTermsSummary: {
    en: 'Change in other terms for loans and grants',
    nb: 'Endring i øvrige vilkår for lån og tilskudd',
    nn: 'Endring i øvrige vilkår for lån og tilskot',
  },
  maintenanceAmendmentOfTermsAbout1: {
    en: 'When changing other terms associated with loans, grants or guarantees, you must seek approval from Innovation Norway before the changes are implemented.',
    nb: 'Ved endring i øvrige vilkår tilknyttet lån, tilskudd eller garanti, må du søke godkjenning hos Innovasjon Norge før endringene gjennomføres.',
    nn: 'Ved endring i øvrige vilkår tilknytt lån, tilskot eller garanti, må du søkje godkjenning hos Innovasjon Norge før endringane blir gjennomførte.',
  },
  maintenanceAmendmentOfTermsAbout2: {
    en: 'This includes for example:',
    nb: 'Dette gjelder for eksempel:',
    nn: 'Dette gjeld mellom anna:',
  },
  maintenanceAmendmentOfTermsList1: {
    en: 'Changes in loan term',
    nb: 'Endringer av løpetid',
    nn: 'Endringar av løpetid',
  },
  maintenanceAmendmentOfTermsList2: {
    en: 'Changes in special terms',
    nb: 'Endringer av særvilkår',
    nn: 'Endringar av særvilkår',
  },
  maintenanceAmendmentOfTermsList3: {
    en: 'Changes in project or investment plan',
    nb: 'Endringer i prosjekt eller investeringsplan',
    nn: 'Endringar i prosjekt eller investeringsplan',
  },
  maintenanceAmendmentOfTermsList4: {
    en: "Relocation of borrower's/pledgor's business - wholly or in part",
    nb: 'Flytting av låntakers/pantsetters virksomhet - helt eller delvis',
    nn: 'Flytting av låntakaren/pantsetjaren si verksemd - heilt eller delvis',
  },
  maintenanceAmendmentOfTermsButton: {
    en: 'Apply for changes in other terms',
    nb: 'Søk om endringer i øvrige vilkår',
    nn: 'Søk om endringar i øvrige vilkår',
  },
  maintenanceAmendmentOfTermsAlertHeading: {
    en: 'You cannot apply for amendment of terms',
    nb: 'Du kan ikke søke om endring i øvrige vilkår',
    nn: 'Du kan ikkje søkje om endring i øvrige vilkår',
  },
  maintenanceAmendmentOfTermsAlertParagraph: {
    en: 'If you have questions related to this, you can contact us at kundesupport@innovasjonnorge.no.',
    nb: 'Har du spørsmål knyttet til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
    nn: 'Har du spørsmål knytta til dette kan du kontakte oss på kundesupport@innovasjonnorge.no.',
  },
  revolvingLoanSummary: {
    en: 'Revolving loan',
    nb: 'Løpende lån',
    nn: 'Løpande lån',
  },
  revolvingLoanAbout: {
    en: 'On our website you can read more about the following changes related to revolving loans:',
    nb: 'På nettsidene våre kan du lese mer om følgende endringer knyttet til løpende lån:',
    nn: 'På nettsidene våre kan du lese meir om følgjande endringar knytta til løpande lån:',
  },
  revolvingLoanList1: {
    en: 'Change of payment plan',
    nb: 'Endring av betalingsplan',
    nn: 'Endring av betalingsplan',
  },
  revolvingLoanList2: {
    en: 'Waiver of guarantee',
    nb: 'Frafall av kausjon',
    nn: 'Frafall av kausjon',
  },
  revolvingLoanList3: {
    en: 'Consent to merger and division',
    nb: 'Samtykke til fusjon og fisjon',
    nn: 'Samtykke til fusjon og fisjon',
  },
  revolvingLoanList4: {
    en: 'Change of debtor',
    nb: 'Debitorskifte',
    nn: 'Debitorskifte',
  },
  revolvingLoanList5: {
    en: 'Breach of loan',
    nb: 'Mislighold av lån',
    nn: 'Mislighold av lån',
  },
  revolvingLoanList6: {
    en: 'Principles for debt arrangements',
    nb: 'Prinsipper ved gjeldsordninger',
    nn: 'Prinsippar ved gjeldsordningar',
  },
  revolvingLoanLink: {
    en: 'Change in terms for revolving loans',
    nb: 'Endring i vilkår for løpende lån',
    nn: 'Endring i vilkår for løpande lån',
  },
  revolvingStartupLoanSummary: {
    en: 'Revolving startup loan',
    nb: 'Løpende oppstartslån',
    nn: 'Løpande oppstartslån',
  },
  revolvingStartupLoanAbout: {
    en: 'On our website you can read more about the following changes related to revolving startup loans:',
    nb: 'På nettsidene våre kan du lese mer om følgende endringer knyttet til løpende oppstartslån:',
    nn: 'På nettsidene våre kan du lese meir om følgjande endringar knytta til løpande oppstartslån:',
  },
  revolvingStartupLoanList1: {
    en: 'Installment deferral',
    nb: 'Avdragsutsettelse',
    nn: 'Avdragsutsetjing',
  },
  revolvingStartupLoanList2: {
    en: 'Payment deferral',
    nb: 'Betalingsutsettelse',
    nn: 'Betalingsutsetjing',
  },
  revolvingStartupLoanList3: {
    en: 'Conversion to repayment loan',
    nb: 'Konvertering til nedbetalingslån',
    nn: 'Konvertering til nedbetalingslån',
  },
  revolvingStartupLoanList4: {
    en: 'Interest exemption or interest accumulation',
    nb: 'Rentefritak eller renteakkumulering',
    nn: 'Rentefritak eller renteakkumulering',
  },
  revolvingStartupLoanList5: {
    en: 'Breach over 90 days',
    nb: 'Mislighold over 90 dager',
    nn: 'Mislighold over 90 dagar',
  },
  revolvingStartupLoanList6: {
    en: 'Guarantor',
    nb: 'Kausjonist',
    nn: 'Kausjonist',
  },
  revolvingStartupLoanList7: {
    en: 'Collection of guarantee',
    nb: 'Inndrivelse av kausjon',
    nn: 'Inndrivelse av kausjon',
  },
  revolvingStartupLoanList8: {
    en: 'Liquidation of company',
    nb: 'Avvikling av selskap',
    nn: 'Avvikling av selskap',
  },
  revolvingStartupLoanList9: {
    en: 'Debt negotiation',
    nb: 'Gjeldsforhandling',
    nn: 'Gjeldsforhandling',
  },
  revolvingStartupLoanList10: {
    en: 'Bankruptcy',
    nb: 'Konkurs',
    nn: 'Konkurs',
  },
  revolvingStartupLoanList11: {
    en: 'Change of debtor',
    nb: 'Debitorskifte',
    nn: 'Debitorskifte',
  },
  revolvingStartupLoanList12: {
    en: 'Acquisition',
    nb: 'Oppkjøp',
    nn: 'Oppkjøp',
  },
  revolvingStartupLoanLink: {
    en: 'Change in terms for revolving startup loans',
    nb: 'Endring i vilkår for løpende oppstartslån',
    nn: 'Endring i vilkår for løpande oppstartslån',
  },
  changeRequestsHeading: {
    en: 'Drafts and submitted change requests',
    nb: 'Utkast og innsendte endringssøknader',
    nn: 'Utkast og innsendte endringssøknader',
  },
  changeRequestsParagraph: {
    en: 'If you have saved a draft or submitted a change application, you can find it here.',
    nb: 'Har du lagret et utkast eller sendt inn en endringssøknad, kan du finne den her.',
    nn: 'Har du lagra eit utkast eller sendt inn ein endringssøknad, kan du finne han her.',
  },
  changeRequestsLink: {
    en: 'See your change requests',
    nb: 'Se dine endringssøknader',
    nn: 'Sjå endringssøknadene dine',
  },
} as const;
